"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITerrainType = void 0;
var ITerrainType;
(function (ITerrainType) {
    ITerrainType["Incline"] = "Incline";
    ITerrainType["Flat"] = "Flat";
    ITerrainType["Rolling"] = "Rolling";
    ITerrainType["Decline"] = "Decline";
})(ITerrainType || (exports.ITerrainType = ITerrainType = {}));
//# sourceMappingURL=terrain-type.js.map